define('app/views/home_travel_widget_view',['app/setup'], function (takhfifan) {
  takhfifan.HomeTravelWidgetView = takhfifan.BaseView.extend({
    initialize: function () {
      var _this = this;
      $('.travel-search__btn').on('click',function () {
        var serachQuery=$('#travelSearch').val();
        var url=$(this).data('url');
        window.location.replace(url+'#travel_search/location/'+ serachQuery);
      })
    },
  });
});




